import React from "react";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { ToolButton } from "../../../../components";
import { IToolButtonProps } from "../../../../interfaces";
import { hideAlert, showAlert } from "../../../../components/alert/Alert";
import { AlertTypeEnum } from "../../../../enums";
import { useStateReducer, useSubscription } from "../../../../hooks";
import { notiDataService } from "../../services";
import { useNavigate } from "react-router-dom";
import { UserPermissions } from "../../../../../src/definitions";
import {  securityService } from "../../../../../src/_global/services";

export default function SendButton({ config, item }: IToolButtonProps) {
  const navigate = useNavigate();
  const { id: moduleId } = config;
  const { id: itemId } = item;
  const [state, setState] = useStateReducer({});

  useSubscription("notification", (noti: any) => {
    setState({ noti: noti });
  });

  const handleClick = () => {
    const handleYes = async () => {
      await notiDataService.addNoti(state.noti.message, state.noti.selectedCard_id, state.noti._id, state.noti.title);

      navigate(`/${moduleId}`, { replace: true });
    };

    if (state.noti && state.noti["selectedCard_id"] && state.noti["message"] && state.noti["title"]) {
      handleYes();
      return;
    }

    showAlert({
      content: "Please specify values that is required?",
      options: {
        actions: [
          { text: "Okay", onClick: hideAlert, primary: true },
        ],
        type: AlertTypeEnum.Question,
      },
    });

  };

  return (
    <ToolButton
      text="Send"
      icon={faSave}
      path={`/${moduleId}/${itemId}`}
      primary
      raised
      onClick={handleClick}
      invalid={!securityService.checkRoleAccess(UserPermissions.editCustomNotifications)}
    />
  );
}
